import React from "react";
import {
  Autocomplete,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { FormikProps } from "formik";

import Grid2 from "@mui/material/Grid2"; // استفاده از Grid2
import { IBaseAgreement } from "src/interface/IBaseAgreements";

// ساخت schema برای اعتبارسنجی با yup

const BaseAgreementsForm = ({
  formik,
}: {
  formik: FormikProps<IBaseAgreement>;
}) => {
  return (
    <>
      <Grid2 container spacing={1} marginY={1}>
        <Grid2 size={7}>
          <TextField
            {...formik.getFieldProps("name")} // استفاده از ویژگی‌های فرمیک
            label="سال قرار داد"
            type="number"
            onChange={(e) => {
              const value = e.target.value;
              if (value.length <= 4) {
                formik.setFieldValue("name", value); // Only update if 4 or fewer digits
              }
            }}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={(formik.touched.name && formik.errors.name) as boolean}
            variant="outlined"
            fullWidth
          />
        </Grid2>
        <Grid2 size={5}>
          <TextField
            {...formik.getFieldProps("discount")} // استفاده از ویژگی‌های فرمیک
            label="درصد تخفیف"
            type="number"
            onChange={(e) => {
              const value = e.target.value;
              if (value.length <= 4) {
                formik.setFieldValue("discount", value); // Only update if 4 or fewer digits
              }
            }}
            error={formik.touched.discount && Boolean(formik.errors.discount)}
            helperText={
              (formik.touched.discount && formik.errors.discount) as boolean
            }
            variant="outlined"
            fullWidth
          />
        </Grid2>
      </Grid2>
      <Grid2 container spacing={1} marginY={1}>
        <Grid2 size={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={formik.values.isActive || false}
                onChange={(e) =>
                  formik.setFieldValue("isActive", e.target.checked)
                }
                name="isActive"
              />
            }
            label="فعال کردن این پایه قرارداد (فقط یک پایه قرارداد می‌تواند فعال باشد)"
          />
        </Grid2>
      </Grid2>
    </>
  );
};

export default BaseAgreementsForm;
